export class UpdateUserRole {
    public userID: string;
    public providerID: number;
    public addToRoles: string[];
    public removeFromRoles: string[];
}
